import { MediaQueryService } from '@workbench/core';

/**
 * Exporting Workbench MediaQuery Services
 */
export { WB_RESIZE_EVENT_NAME, MEDIA_QUERY_SIZES, MediaQueryService } from '@workbench/core';

/**
 * @name Breakpoints
 *
 * @description List of the breakpoint names
 *
 */
export const Breakpoints = {
  mq1: 'mq1',
  mq2: 'mq2',
  mq3: 'mq3',
  mq4: 'mq4',
  mq5: 'mq5',
  mq6: 'mq6',
};

/**
 * @name mobileBreakpoints
 *
 * @description List of breakpoint names for mobile
 *
 */
export const mobileBreakpoints = [Breakpoints.mq1, Breakpoints.mq2];

/**
 * @name tabletBreakpoints
 *
 * @description List of breakpoint names for tablet
 *
 */
export const tabletBreakpoints = [Breakpoints.mq3, Breakpoints.mq4];

/**
 * @name desktopBreakpoints
 *
 * @description List of breakpoint names for desktop
 */
export const desktopBreakpoints = [Breakpoints.mq5, Breakpoints.mq6];

export const mediaQueryService = new MediaQueryService(window);
